<template>
    <div class="ps">
        <div class="ps_top">
            <i class="el-icon-edit"></i>
            <div>账号管理</div>
        </div>
        <div class="ps_search">
            <div class="search_box">
                <el-input class="" v-model="searchinput" placeholder="请输入内容"></el-input>
            </div>
            <div class="button_box">
                <el-button @click="resetting()">重置</el-button>
                <el-button @click="query()">查询</el-button>
            </div>
        </div>
        <div class="ps_add">
            <el-button @click="add()">添加账号</el-button>
        </div>
        <div class="ps_table">
            <el-table
                :header-cell-style="{ background:'#e2d2d2'}"
                :data="tableData"
                style="width: 100%">
                <el-table-column
                    type="index"
                    label="序号">
                </el-table-column>
                <el-table-column
                    prop="name"
                    label="姓名">
                </el-table-column>
                <el-table-column
                    prop="phone"
                    label="手机号码">
                </el-table-column>
                <!-- <el-table-column
                    label="权限">
                    <template slot-scope="scope">
                        <span v-for="(item,index) of JSON.parse(scope.row.menu)" :key="index"> {{item.name}}、</span>
                      
                    </template>
                </el-table-column> -->
                <el-table-column
                    label="操作">
                    <template slot-scope="scoped">
                        <el-button  type="text" @click="edit(scoped.row)">编辑</el-button>
                        <el-popconfirm
                            title="确定要重置密码吗？"
                            @confirm="msn(scoped.row)"
                            >
                            <el-button  type="text" slot="reference">重置密码</el-button>
                        </el-popconfirm>
                        <el-button type="text" v-if="scoped.row.active==0" @click="ed(0,scoped.row)">启用</el-button>
                        <el-button type="text" v-if="scoped.row.active==1" @click="ed(1,scoped.row)">禁用</el-button>
                        <el-popconfirm
                            title="这是一段内容确定删除吗？"
                            @confirm="del(scoped.row)"
                            >
                            <el-button style="margin: 0px 5px;" type="text" slot="reference">删除</el-button>
                        </el-popconfirm>
                        <!-- <el-button  type="text" @click="del(scoped.row)">删除</el-button> -->
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="ps_pagination">
            <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="page.currentPage"
                :page-sizes="[10, 20, 30, 40]"
                layout="total, sizes, prev, pager, next, jumper"
                :total="page.totalElements">
            </el-pagination>
        </div>
        <!-- 添加/编辑用户 -->
        <el-dialog
            :title="productTitle"
            :visible.sync="productDialogVisible"
            width="30%"
            class="dislogp">
            <el-form :model="ruleForm"  ref="ruleForm" label-width="100px" class="demo-ruleForm">
                <el-form-item label="姓名" prop="name">
                    <el-input v-model="ruleForm.name"></el-input>
                </el-form-item>
                <el-form-item label="手机号码" class="itemtwo">
                    <el-input v-model="ruleForm.phone"></el-input>
                </el-form-item>
                <!-- <el-form-item label="权限功能">
                    <el-checkbox  v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
                    <el-checkbox-group v-model="checkList" 
                        class="choice_box"
                        v-for="(item,index) of menulist" :key="index"
                        @change="handleCheckedCitiesChange"
                        >
                        <el-checkbox :label="item.id">{{ item.name }}</el-checkbox>
                    </el-checkbox-group>
                </el-form-item> -->
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="addcancel()">取 消</el-button>
                <el-button type="primary"  v-if="productTitle=='添加用户'" @click="sueradd()">确 定</el-button>
                <el-button type="primary" v-if="productTitle=='编辑用户'"  @click="sueredit('ruleForm')">确 定</el-button>
            </span>
        </el-dialog>
        
    </div>
</template>
<script>
    import baseurl from '../../utils/index'
    export default{
        data(){
            return{
                baseurl,
                ruleForm:{
                    name: '',
                    phone:'',
                    limits:[],
                },
               
                searchinput:'',
                tableData: [],
                page:{
                    pagesize:10,
                    pagescount:1,
                    totalElements:0,
                    currentPage:1
                },
                productDialogVisible:false,
                modifynumber:false,
                productTitle:'',
                scoped:null,
                checked:null,//全选
                checkList:[],//多选
                menulist:null,//权限列表
                checkAll: false,
                isIndeterminate:true,
                item:null,
            }
        },
        created(){
            this.axioslist()
            // this.menu()
        },
        methods:{
            //账号的启用禁用
            ed(type,user){
                // 0:启用 1:禁用
                if(type==0){
                    this.$http.put(`/userActive?id=${user.id}&active=${1}`).then((res)=>{
                        if(res.code==200){
                            this.$message({
                                message:'启用成功',
                                type:'success'
                            })
                            this.page.pagesize=10;
                            this.page.pagescount=1;
                            this.page.currentPage=1;
                            this.axioslist()
                        }
                    })
                }else if(type==1){
                    this.$http.put(`/userActive?id=${user.id}&active=${0}`).then((res)=>{
                        if(res.code==200){
                            this.$message({
                                message:'禁用成功',
                                type:'success'
                            })
                            this.page.pagesize=10;
                            this.page.pagescount=1;
                            this.page.currentPage=1;
                            this.axioslist()
                        }
                    })
                }
            },
            //删除
            del(scoped){
                console.log(111,scoped);
                this.$http.delete(`/user?id=${scoped.id}`).then((res)=>{
                    console.log(res);
                    if(res.code==200){
                        this.$message({
                            message:'删除成功',
                            type:'success'
                        })
                        this.page.pagesize=10;
                        this.page.pagescount=1;
                        this.page.currentPage=1;
                        this.axioslist()
                    }
                })
            },
            //重置密码
            msn(scoped){
                console.log(11,scoped);
                this.$http.put(`/resetPassword?id=${scoped.id}`).then((res)=>{
                    if(res.code==200){
                        this.$message({
                            message:'重置密码成功',
                            type:'success'
                        })
                        this.page.pagesize=10;
                        this.page.pagescount=1;
                        this.page.currentPage=1
                        this.axioslist()
                    }else{
                        this.$message({
                            message:res.message,
                            type:'success'
                        })
                    }
                })
                
            },
            //修改序号确定
            suermsn(formName){
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        let obj={
                            "productId":this.scoped.id ,//产品id
                            "sort":Number( this.ruleForm.num),//新序号
                        }
                        console.log(1111,obj);
                        this.$http.put(`/sort/product?productId=${this.scoped.id }&sort=${Number( this.ruleForm.num)}`).then((res)=>{
                            console.log(res);
                            if(res.code==200){
                                this.$message({
                                    message: '序号修改成功',
                                    type: 'success'
                                });
                                this.modifynumber=false;
                                this.page.pagesize=10;
                                this.page.pagescount=1;
                                this.page.currentPage=1;
                                this.ruleForm.num=null;
                                this.axioslist()
                            }
                        })
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            },
            //修改序号为数字
            intnumber(){
                this.ruleForm.num=this.ruleForm.num.replace(/[^\d/]/g, "")
            },
            //编辑产品确定
            sueredit(){
                console.log(111,this.ruleForm);
                let issuer=false
                if(this.ruleForm.name==''){
                    this.$message({
                        message:'用户名不能为空',
                        type:'error'
                    })
                }else if(this.ruleForm.phone==''){
                    this.$message({
                        message:'手机号不能为空',
                        type:'error'
                    })
                }else{
                    issuer=true
                }
                // let authority=[]
                // for(let i=0;i<this.checkList.length;i++){
                //     for(let j=0;j<this.menulist.length;j++){
                //         if(this.checkList[i]==this.menulist[j].id){

                //             console.log(111);
                //             authority.push({
                //                 id:this.menulist[j].id,
                //                 name:this.menulist[j].name
                //             })
                //         }
                //     }
                // }
                if(issuer==true){
                    let obj={
                        name:this.ruleForm.name,
                        phone:this.ruleForm.phone,
                        id:this.scoped.id,
                        // menu:JSON.stringify( authority)
                    }
                    this.$http.put('/user',obj).then((res)=>{
                        if(res.code==200){
                            console.log(111,res);
                            this.$message({
                                message:'编辑用户成功',
                                type:'success'
                            })
                            this.productDialogVisible=false;
                            this.page.pagesize=10;
                            this.page.pagescount=1;
                            this.page.currentPage=1
                            this.axioslist()
                        }else{
                            this.$message({
                                message:res.message,
                                type:'error'
                            })
                        }
                    })
                }
            },
            //编辑产品
            edit(scoped){
                this.scoped=scoped;
                this.productTitle='编辑用户';
                this.productDialogVisible=true;
                this.ruleForm.name=scoped.name;
                this.ruleForm.phone=scoped.phone;
                // let menus=JSON.parse( scoped.menu);
                // this.checkList=[]
                // this.item=scoped;
                // for(let i=0;i<menus.length;i++){
                //     this.checkList.push(menus[i].id)
                // }
                // if(menus.length==this.menulist.length){
                //     console.log(1111);
                //     this.checkAll=true
                // }
            },
            //请求数据列表
            axioslist(){
                let obj={
                    pageIndex:this.page.pagescount,//页码
                    pageSize:this.page.pagesize,//页面大小
                    key:this.searchinput,//描述
                }
                this.$http.get(`/page/user?pageIndex=${this.page.pagescount}&pageSize=${this.page.pagesize}&key=${this.searchinput}`).then((res)=>{
                    if(res.code==200){;
                        this.page.totalElements=res.data.totalElements
                        this.tableData=res.data.data;

                    }
                })
            },
            //重置
            resetting(){
                this.page.pagesize=10;
                this.page.pagescount=1;
                this.page.currentPage=1
                this.searchinput='';
                this.axioslist()
            },
            //查询
            query(){
                this.page.pagesize=10;
                this.page.pagescount=1;
                this.page.currentPage=1
                this.axioslist()
            },
            //添加产品
            add(){
                // console.log(666666666);
                this.productTitle='添加用户'
                this.productDialogVisible=true;
                this.ruleForm.name=null;
                this.ruleForm.phone=null;
                this.checkList=[];
                this.checkAll=false
                
            },
            //添加产品取消
            addcancel(){
                this.productDialogVisible=false;
                this.ruleForm.name=null;
                this.ruleForm.imageUrl=null;
                this.ruleForm.textareainput=null;
            },
            //确定添加用户
            sueradd(){
                let issuer=false
                if(this.ruleForm.name==''){
                    this.$message({
                        message:'用户名不能为空',
                        type:'error'
                    })
                }else if(this.ruleForm.phone==''){
                    this.$message({
                        message:'手机号不能为空',
                        type:'error'
                    })
                }else{
                    issuer=true
                }
                // let authority=[]
                // for(let i=0;i<this.checkList.length;i++){
                //     for(let j=0;j<this.menulist.length;j++){
                //         if(this.checkList[i]==this.menulist[j].id){

                //             console.log(111);
                //             authority.push({
                //                 id:this.menulist[j].id,
                //                 name:this.menulist[j].name
                //             })
                //         }
                //     }
                // }
                if(issuer==true){
                    let obj={
                        name:this.ruleForm.name,
                        phone:this.ruleForm.phone,
                        // menu:JSON.stringify( authority)
                    }
                    this.$http.post('/user',obj).then((res)=>{
                        if(res.code==200){
                            console.log(111,res);
                            this.$message({
                                message:'添加用户成功',
                                type:'success'
                            })
                            this.productDialogVisible=false;
                            this.page.pagesize=10;
                            this.page.pagescount=1;
                            this.page.currentPage=1
                            this.axioslist()
                        }else{
                            this.$message({
                                message:res.message,
                                type:'error'
                            })
                        }
                    })
                }

            }, 
            handleCheckAllChange(val) {
                let checkAll=[]
                for(let i=0;i<this.menulist.length;i++){
                    checkAll.push(this.menulist[i].id)
                }
                val==true?this.checkList=checkAll :this.checkList=[]
                
            },
            handleCheckedCitiesChange(val){
            
               this.checkAll= this.isIndeterminate=  (val.length==this.menulist.length)
            },  
            // menu(){
            //     this.$http.get('/menu').then((res)=>{
            //         if(res.code==200){
            //             this.menulist=res.data
            //         }
            //     })
            // },
            //上传图片
            uploadsuccess(res){
                if(res.code==200){
                    this.ruleForm.imageUrl=res.data
                }
            },
            handleCurrentChange(val){
                this.page.pagescount=val;
                this.page.currentPage=val;
                
                this.axioslist()
                console.log(111,this.page.pagescount);
            },
            handleSizeChange(val){
                this.page.pagesize=val;
                this.axioslist()
                console.log(222,this.page.pagesize);
            },
        }
    }
</script>
<style lang="less" scoped>
    .choice_box{
        box-sizing: border-box;
        padding-left: 20px;
    }
    /deep/.el-form-item__label::before{
        content: '*';
        color: red;
        margin-right: 5px;
    }
    textarea{
        resize: none;
    }
    textarea:focus {
    outline: none
    }
    .not_upload{
        border: 1px  dashed red ;
    }
    .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }
    .avatar-uploader .el-upload:hover {
        border-color: #409EFF;
    }
    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 178px;
        height: 178px;
        line-height: 178px;
        text-align: center;
    }
    .avatar {
        width: 178px;
        height: 178px;
        display: block;
    }
    .ps{
        width: 100%;
        height: 100%;
        box-sizing: border-box ;
        background: #fff;
        min-height: 829px;
        padding: 10px 20px;
        .ps_top{
            width: 100%;
            height: 20px;
            display: flex;
            align-items: center;
            box-sizing: border-box
        }
        .ps_search{
            box-sizing: border-box;
            width:100%;
            height: 50px;
            border: 1px solid #d7d7d7;
            margin: 10px 0px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 10px 0px;
            .search_box{
                box-sizing: border-box;
                padding-left: 20px;
                width: 300px;
            }
            .button_box{
                box-sizing: border-box;
                padding-right: 20px;
            }
        }
        .ps_add{
            width: 100%;
            display: flex;
            justify-content: right;
        }
        .ps_table{
            width: 100%;
            max-height: 75%;
            overflow: scroll;
            overflow-x: hidden;
            box-sizing: border-box;
            margin: 10px 0px;
            .img_box{
                border: 1px solid red;
            }
        }
        .ps_pagination{
            width: 100%;
            height: 8%;
            box-sizing: border-box;
            display: flex;
            align-items: center;
            justify-content: right;
        }
        .dislogp{
           .itemtwo{
                .refresh{
                    line-height: 15px;
                }
           }
        }
    }
</style>